import { EmailAlt, Linkedin, Phone } from '@clearkit/icons';
import classnames from 'classnames';
import {
  CKContainerProps,
  CKLayoutHorizontal,
  CKTooltip,
  cloneChildren,
} from 'clearkit';

type TokenProps = CKContainerProps & {
  hasToken?: boolean;
  title: React.ReactNode;
};

const Token = ({ children, hasToken, title }: TokenProps) => {
  const Content = () => (
    <span className="block p-1 -mt-1 text-gray-900 border border-gray-200 rounded">
      {cloneChildren({
        children,
        newProps: {
          className: classnames('w-4 h-4', {
            'opacity-20': !hasToken,
          }),
        },
      })}
    </span>
  );

  return hasToken ? (
    <CKTooltip targetClassName="flex" tooltip={title}>
      <Content />
    </CKTooltip>
  ) : (
    <Content />
  );
};

const TokenGroup = ({ children, className, ...rest }: CKContainerProps) => (
  <CKLayoutHorizontal
    {...rest}
    className={classnames('h-full', className)}
    gap="0.5rem"
    justifyContent="start"
  >
    {children}
  </CKLayoutHorizontal>
);

type TokensProps = {
  hasTwitter?: boolean;
  hasLinkedIn?: boolean;
  hasPhone?: boolean;
  hasEmail?: boolean;
  isDealMaker?: boolean;
};

export const Tokens = ({ hasEmail, hasLinkedIn, hasPhone }: TokensProps) => (
  <CKLayoutHorizontal
    alignItems="center"
    className="h-3 divide-x divide-gray-200 basis-auto shrink-0 grow min-h-[1.5rem]"
    gap="0.75rem"
    justifyContent="start"
  >
    <TokenGroup>
      {/* <Token hasToken={isDealMaker} title="Prospect is a deal maker">
        <Money
          className={classnames({
            'fill-gradient-br-green': isDealMaker,
          })}
        />
      </Token> */}
      <Token hasToken={hasLinkedIn} title="Prospect has LinkedIn">
        <Linkedin
          className={classnames({
            'text-linkedin': hasLinkedIn,
          })}
        />
      </Token>
      <Token hasToken={hasPhone} title="Prospect has a phone number">
        <Phone />
      </Token>
      <Token hasToken={hasEmail} title="Prospect has an email address">
        <EmailAlt />
      </Token>
    </TokenGroup>
  </CKLayoutHorizontal>
);
